import ReactDOM from 'react-dom';
import React from 'react';
import {HelmetProvider} from 'react-helmet-async';
import CmsSite from './Components/CmsSite';
import AppConfig from './AppConfig';
import EpiContext from './Spa';
import ComponentPreLoader, {IComponentPreloadList} from './Loaders/ComponentPreLoader';
import IServiceContainer from './Core/IServiceContainer';
import DefaultServiceContainer from './Core/DefaultServiceContainer';

export default function InitBrowser(config: AppConfig, containerId?: string, serviceContainer?: IServiceContainer) {
  if (!serviceContainer) {
    serviceContainer = new DefaultServiceContainer();
  }
  EpiContext.init(config, serviceContainer);

  const container = document.getElementById(containerId ? containerId : 'epi-page-container');
  const app = (
    <HelmetProvider>
      <CmsSite context={EpiContext} />
    </HelmetProvider>
  );

  if (container && container.childElementCount > 0) {
    if (EpiContext.isDebugActive()) console.info('Hydrating existing render, Stage 1. Preloading components ...');
    const components: IComponentPreloadList = EpiContext.config().preLoadComponents || [];
    const loader = EpiContext.componentLoader();
    ComponentPreLoader.load(components, loader).finally(() => {
      if (EpiContext.isDebugActive()) console.info('Hydrating existing render, Stage 2. Hydration ...');
      ReactDOM.hydrate(app, container);
    });
  } else {
    if (EpiContext.isDebugActive()) console.info('Building new application');
    ReactDOM.render(app, container);
  }
}
